module.exports = __webpack_public_path__ + "static/inspire-799e98447273229c63650aef678b258a.png";